import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get initials from name or email
 * Returns first 2 characters of name initials or email prefix
 */
export function getInitials(name?: string | null, email?: string | null): string {
  if (name) {
    return name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
  }
  return email?.slice(0, 2).toUpperCase() || 'U'
}
